import { useState, useEffect, useCallback } from 'react';
import { useCheckoutApi } from './../../../../../../../../../../react-common/api/useCheckoutApi';
import { useAppContext } from '@app/react-common/AppContext';
import { Checkout } from '../../../../../checkout/react/models/Checkout';

const useCheckouts = () => {
  const [checkouts, setCheckouts] = useState<Checkout[]>([]);
  const { showToast } = useAppContext();

  const failureHandler = useCallback(async () => {
    showToast({ message: `An error has ocurred. Please contact support if the problem persists.`, mode: 'danger' });
    await fetchData();
  }, []);

  const checkoutApi = useCheckoutApi(failureHandler);

  const fetchData = async () => {
    const response = await checkoutApi.get('/admin/v1/shipping-methods-group?limit=9999');
    setCheckouts(response.data as Checkout[]);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return {
    checkouts,
  };
};

export default useCheckouts;
